import types from '../../types';

const limitations = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_LIMITATIONS_START:
      return { ...state, loading: true };

    case types.GET_LIMITATIONS_SUCCESS:
      return { data: payload, loading: false };

    case types.GET_LIMITATIONS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default limitations;
